import { ElementTargetProps, getElementBySelection } from "./element_select";
import SmallButton from "./small_button";

type FullscreenButtonProps = object & ElementTargetProps;

export default function FullscreenButton(props?: FullscreenButtonProps) {
  if (!document.fullscreenEnabled) {
    return;
  }

  const target = props || {};
  const fallbackTarget = {
    className: "app-body",
  };

  return (
    <SmallButton
      title="Fullscreen"
      onClick={() =>
        document.fullscreenElement
          ? document.exitFullscreen()
          : getElementBySelection(target, fallbackTarget).requestFullscreen()
      }
    >
      ⛶
    </SmallButton>
  );
}
